import { prefersReducedMotion } from '../lib/lenis';

// Smart-search demo: erases the query, types the next one, then swaps in its
// results. Every demo's results are already in the markup (the first one
// visible), so with no JS — or reduced motion — the section is a complete
// static example. Runs only while the panel is on screen.
const TYPE_MS = 55;
const ERASE_MS = 22;
const HOLD_MS = 3600;

const wait = (ms: number) => new Promise<void>((resolve) => window.setTimeout(resolve, ms));

export function initSearchDemo(): void {
  const panel = document.querySelector<HTMLElement>('[data-search-demo]');
  if (!panel || prefersReducedMotion()) return;

  const queryEl = panel.querySelector<HTMLElement>('[data-search-query]');
  const results = Array.from(panel.querySelectorAll<HTMLElement>('[data-search-result]'));
  if (!queryEl || results.length < 2) return;

  let visible = false;
  let running = false;
  let index = 0;

  const untilVisible = async () => {
    while (!visible) await wait(250);
  };

  const loop = async () => {
    running = true;
    for (;;) {
      await wait(HOLD_MS);
      await untilVisible();

      const current = results[index];
      index = (index + 1) % results.length;
      const next = results[index];
      const target = next.dataset.query || '';

      current.classList.add('is-typing');
      for (let t = queryEl.textContent || ''; t.length; ) {
        t = t.slice(0, -1);
        queryEl.textContent = t;
        await wait(ERASE_MS);
      }
      for (let i = 1; i <= target.length; i += 1) {
        queryEl.textContent = target.slice(0, i);
        await wait(TYPE_MS);
      }
      await wait(250);
      current.classList.remove('is-active', 'is-typing');
      next.classList.add('is-active');
    }
  };

  new IntersectionObserver(
    (entries) => {
      visible = entries.some((e) => e.isIntersecting);
      if (visible && !running) void loop();
    },
    { threshold: 0.35 },
  ).observe(panel);
}
